(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-swatches"]) return;
  try {
    
  (function() {
    // hide/show swatch prices
    getCartEvent();
    function getCartEvent() {
      document.documentElement.dispatchEvent(new CustomEvent('theme:cart:get', {
        bubbles: true
      }));
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
